import React from 'react';

const reasons = [
  {
    icon: '/pictures/security_80f8ac1422.svg',
    title: 'Security first',
    description: 'The true cost of a successful attack on the data and systems can cause much more severe financial loss and identity theft than you ever thought. Protecting your business is our top-of-mind value that can also extend to being an advocate community for cybersecurity.',
  },
  {
    icon: '/pictures/innovation_561a49ed62.svg',
    title: 'Innovation',
    description: 'We innovate our team, our customer and our products. Innovation upgrades the operating systems of the business or introduces modern technologies for automation. We believe that the amalgamation of innovation and automation can help companies witness innumerable growth.',
  },
  {
    icon: '/pictures/stack_248277a23c.svg',
    title: 'KIS - Keep it simple',
    description: "Simple is not about reducing or doing less just to get rid of volume or quantity. It's about breaking things down to clarify and get to the real meaning, which takes a lot of thought and analysis. We highly focused on the output to know our target audience and the objective and develop the communication accordingly.",
  },
];

export default function WhyChooseUs() {
  return (
    <section style={{ padding: '100px 24px', background: '#F9FAFB' }}>
      <div style={{ maxWidth: '1200px', margin: '0 auto' }}>
        {/* Header */}
        <div style={{ marginBottom: '64px' }}>
          <div style={{ display: 'flex', alignItems: 'center', gap: '8px', marginBottom: '16px' }}>
            <div style={{ width: '24px', height: '3px', backgroundColor: '#0099CC', borderRadius: '2px' }}></div>
            <span style={{ fontSize: '14px', fontWeight: '600', color: '#0099CC', textTransform: 'uppercase', letterSpacing: '1px' }}>
              Why Us
            </span>
          </div>
          <h2 style={{ fontSize: 'clamp(28px, 3vw, 40px)', fontWeight: '700', color: '#111827', marginBottom: '12px', letterSpacing: '-0.5px' }}>
            Why choose us?
          </h2>
          <p style={{ fontSize: '17px', color: '#6B7280', maxWidth: '560px', lineHeight: 1.7 }}>
            We integrated them into everything we do and are deeply rooted in our legacy and culture.
          </p>
        </div>

        {/* Cards */}
        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(3, 1fr)', gap: '32px' }}>
          {reasons.map((item, idx) => (
            <div
              key={idx}
              className="service-card"
              style={{
                background: 'white',
                borderRadius: '16px',
                padding: '40px 32px',
                border: '1px solid #E5E7EB',
              }}
            >
              <div style={{
                width: '72px',
                height: '72px',
                borderRadius: '16px',
                background: '#F0F9FF',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                marginBottom: '24px',
                padding: '14px',
              }}>
                <img src={item.icon} alt={item.title} style={{ width: '100%', height: '100%', objectFit: 'contain' }} />
              </div>
              <h3 style={{ fontSize: '20px', fontWeight: '700', color: '#111827', marginBottom: '14px' }}>
                {item.title}
              </h3>
              <p style={{ fontSize: '15px', color: '#6B7280', lineHeight: 1.75, margin: 0 }}>
                {item.description}
              </p>
            </div>
          ))}
        </div>
      </div>

      <style>{`
        @media (max-width: 1024px) {
          .why-grid { grid-template-columns: 1fr 1fr !important; }
        }
        @media (max-width: 640px) {
          .why-grid { grid-template-columns: 1fr !important; }
        }
      `}</style>
    </section>
  );
}
